module.exports = __webpack_public_path__ + "static/Hemlibra_logo_white_FR-4a1de96626dd69db15cba47966520fa8.png";